// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

export const UPDATE_AVAILABLE = "@serviceworker/UPDATE_AVAILABLE";
export const WORKER_INIT = "@serviceworker/INIT";

export const MAP_LAYERS_OPEN = "@map/layers_open";
export const MAP_TASKS_OPEN = "@map/tasks_open";
export const MAP_TASKS_TAB_INDEX = "@map/tasks_tab_index";


export const NAVIGATION_OPEN = "@navigation/open";